// export const WALEE_BASE_URL = "http://localhost:4000/api";
// export const ANALYTICS_BASE_URL = "http://localhost:4000/api";
export const WALEE_BASE_URL = "https://pg.hakeem.tech/api";
export const ANALYTICS_BASE_URL = "https://pg.hakeem.tech/api";
